export enum AdImageStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
}

export interface AdImage {
  id: number;
  name: string;
  url: string;
  hash: string;
  createdAt: number;
  updatedAt: number;
  status: AdImageStatus;
}

export const exampleAdImage: AdImage = {
  id: 1,
  name: 'foo.jpg',
  url: 'fb.me/img',
  hash: '25236jbnkij4b56ijk4b55',
  status: AdImageStatus.ACTIVE,
  createdAt: 1595533091,
  updatedAt: 1595533091,
};
